let config = {
    openCls: 'is--open'
};

export default class Collapsible {
    constructor(element, options) {
        config = $.extend(config, options);

        this.$document = $(document);
        this.$element = $(element);
        this.$control = this.$element.find('[data-collapsible-control]');
        this.isInline = this.$element.attr('aria-collapsible-inline');
    }


    toggle() {
        this.$element.toggleClass(config.openCls).attr('aria-expanded', (index, attr) => {
            return attr === 'true' ? 'false' : 'true';
        });
    }

    documentClick(e) {
        let $target = $(e.target);

        if (!this.$element.is($target) && !$(this.$element).find($target).length) {
            this.$element
                .removeClass(config.openCls)
                .attr('aria-expanded', () => 'false');
        }
    }

    setListeners() {
        this.$control
            .off('click', '', $.proxy(this, 'toggle'))
            .on('click', $.proxy(this, 'toggle'));

        if (!!this.isInline) {
            this.$document
                .off('click', '', $.proxy(this, 'documentClick'))
                .on('click', $.proxy(this, 'documentClick'));
        }
    }

    init() {
        this.setListeners();
    }
}